import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { BALLOON, CASH, FINANCE, LEASE } from '@makemydeal/dr-platform-types';

import { DealSummaryContainer } from './DealSummary.interstate.style';
import { ExpandableAreaProvider, InterstateDealSummarySections, DealSummaryProvider } from '@makemydeal/dr-dash-components';

import Cash from './CashDealSummary.interstate';
import Lease from './LeaseDealSummary.interstate';
import Finance from './FinanceDealSummary.interstate';
import Balloon from './BalloonDealSummary.interstate';

const DealSummary = ({ showDetailedView = false, scopeId }: { showDetailedView?: boolean; scopeId?: string }) => {
    const currentOfferType = useSelector(offerReduxSelectors.getCurrentOfferType);

    const offerComponent = useMemo(() => {
        switch (currentOfferType) {
            case CASH:
                return <Cash />;
            case LEASE:
                return <Lease />;
            case FINANCE:
                return <Finance />;
            case BALLOON:
                return <Balloon />;
        }
    }, [currentOfferType]);

    const dealSummaryContent = !showDetailedView ? (
        <InterstateDealSummarySections.InterstateDetails scopeId={scopeId}>
            {offerComponent}
        </InterstateDealSummarySections.InterstateDetails>
    ) : (
        offerComponent
    );

    const Provider = showDetailedView ? DealSummaryProvider : ExpandableAreaProvider;
    const providerProps = showDetailedView ? { showDetailedView } : {};

    return (
        <Provider {...providerProps}>
            <DealSummaryContainer
                data-testid="deal-summary-container"
                xs={3.9}
                sx={{ padding: 0 }}
                width="100%"
                $isCompactView={!showDetailedView}
            >
                {dealSummaryContent}
            </DealSummaryContainer>
        </Provider>
    );
};

export default DealSummary;
